import _util from '../../utils/';


const resumeLibraryServcie = {
	selectResumeLibrary(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	createResumeLibrary(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateResumeLibrary(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/Put',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	deleteResumeLibrary(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/Delete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	importResumeLibrary(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/Import',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	exportResumeLibrary(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/Export',
			params: data,
			success: resolve,
			error: reject
		})
	},
	downloadResumeLibraryTemplate(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/GetImportTemplate',
			params: data,
			success: resolve,
			error: reject
		})
	},
	initiaInterviewManagement(gets, resolve, reject) {
		_util.request({
			url: '/api/HROffersAuditionArrange/InitInterview',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	createInterviewManagement(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersAuditionArrange/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},	
	sendOffer(data, resolve, reject) {
    _util.request({
      //url: '/api/HROffersEmployManagement/Post',
      url: '/api/HROffersResume/SendOffer',
      method: "post",
      data: data,
      success: resolve,
      error: reject
    })
  },
  sendTestimonial(data, resolve, reject) {
    _util.request({
      url: '/api/HROffersResume/SendTestimonial',
      method: "post",
      data: data,
      success: resolve,
      error: reject
    })
  },
  transActionLibrary(data, resolve, reject) {
	_util.request({
		url: '/api/HROffersResume/Transfer',
		method: "put",
		data: data,
		success: resolve,
		error: reject
	})
},
	initiaResumeLibrary(gets, resolve,reject) {
		_util.request({
			url: '/api/HROffersResume/Post',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	selectResumeLibraryDetail(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersResume/Put',
			params: data,
			success: resolve,
			error: reject
		})
	},
};


export default resumeLibraryServcie;


// WEBPACK FOOTER //
// ./src/services/Recruitment/resume-library-service.js